import script from "./CardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPage.vue?vue&type=script&setup=true&lang=js"

import "./CardPage.vue?vue&type=style&index=0&id=053329f6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-053329f6"]])

export default __exports__